import { useEffect } from 'react'

import { useChatContext } from 'modules/chat/context'
import ChatService from 'modules/chat/service'
import { MobileTab } from 'modules/transmission/types'
import { useTransmissionContext } from 'modules/transmission/context'

export const CHECK_LIVE_CONFIG_INTERVAL = 180000

const useChatVisibility = () => {
  const { transmissionData: { code }, activeTab } = useTransmissionContext()
  const { setShowChat, setIsChatActive, isLoaded } = useChatContext()

  useEffect(() => {
    code && isLoaded && ChatService.subscribeEvents({
      visibilityChanged: setIsChatActive
    })

    return () => {
      code && isLoaded && ChatService.removeEventSubscription({
        visibilityChanged: setIsChatActive
      })
    }
  }, [code, isLoaded, setIsChatActive])

  useEffect(() => {
    if (activeTab === MobileTab.CHAT) {
      setShowChat(true)
    } else if (!activeTab) {
      setShowChat(false)
    }
  }, [activeTab, setShowChat])
}

export default useChatVisibility
